import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE;

/**
 * Ticket transcript viewer - stays on the dashboard origin so an existing
 * login (localStorage) and SiteNav remain intact.
 */
export default function TranscriptPage() {
  const { id } = useParams();
  const [html, setHtml] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id || !API_BASE) {
      setLoading(false);
      setError("Transcript service is not configured.");
      return;
    }

    let cancelled = false;
    const url = `${String(API_BASE).replace(/\/$/, "")}/transcripts/${encodeURIComponent(id)}?raw=1`;

    (async () => {
      try {
        const res = await fetch(url, {
          headers: { Accept: "text/html" },
        });
        if (!res.ok) {
          throw new Error(
            res.status === 404
              ? "Transcript not found."
              : "Failed to load transcript.",
          );
        }
        const text = await res.text();
        if (!cancelled) {
          setHtml(text);
          setError(null);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message || "Failed to load transcript.");
          setHtml(null);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [id]);

  if (loading) {
    return (
      <div className="container" style={{ padding: "48px 20px", textAlign: "center" }}>
        <p style={{ color: "#7b6f62" }}>Loading transcript…</p>
      </div>
    );
  }

  if (error || !html) {
    return (
      <div className="container" style={{ padding: "48px 20px", textAlign: "center" }}>
        <h1 style={{ fontSize: "1.4rem", marginBottom: "8px" }}>Transcript</h1>
        <p style={{ color: "#7b6f62" }}>{error || "Transcript not found."}</p>
      </div>
    );
  }

  return (
    <div
      className="transcript-viewer"
      style={{
        width: "100%",
        height: "calc(100vh - 56px)",
        minHeight: "480px",
      }}
    >
      <iframe
        title="Ticket transcript"
        srcDoc={html}
        sandbox="allow-popups allow-popups-to-escape-sandbox"
        style={{
          width: "100%",
          height: "100%",
          border: 0,
          display: "block",
          background: "#1a1214",
        }}
      />
    </div>
  );
}
